<template>
  <img v-if="user.photo" :src="user.photo" alt="" class="shrink-0 rounded-full object-cover" :class="size" loading="lazy">
  <span v-else class="flex shrink-0 items-center justify-center rounded-full font-bold" :class="[size, user.kind === 'accounts' ? 'bg-[#1c4848] text-white' : 'bg-[#1c4848]/10 text-[#1c4848]']" aria-hidden="true">
    <template v-if="user.kind === 'accounts'">{{ initials }}</template>
    <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="2" width="12" height="20" rx="2.500"/><path d="M11 18h2"/></svg>
  </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  user: { type: Object, required: true },
  size: { type: String, default: 'h-9 w-9 text-[11px]' },
});

const initials = computed(() => props.user.name.split(/\s+/).slice(0, 2).map((word) => Array.from(word)[0] ?? '').join('').toUpperCase());
</script>
